import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HN_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#HN_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HN_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "g",
    {
      mask: "url(#HN_svg__b)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4564F9"
    },
    /* @__PURE__ */ e.createElement("path", { d: "M0 0v8h32V0H0zM0 16v8h32v-8H0zM16.402 12.67l-.866.448.165-.947-.701-.74h.969l.433-.931.433.93h.97l-.702.74.166.948-.867-.447zM10.318 10.503l-.866.447.165-.947-.701-.74h.969l.433-.931.433.93h.97l-.702.74.166.948-.867-.447zM10.318 14.703l-.866.447.165-.947-.701-.74h.969l.433-.93.433.93h.97l-.702.74.166.947-.867-.447zM22.318 10.503l-.866.447.165-.947-.701-.74h.969l.433-.931.433.93h.97l-.702.74.166.948-.867-.447zM22.318 14.703l-.866.447.165-.947-.701-.74h.969l.433-.93.433.93h.97l-.702.74.166.947-.867-.447z" })
  ))
);
export {
  t as default
};
